// Ambar parametreleri API — /api/warehouse-params.
// NOT: Swagger'da yalnizca PUT var (GET yok). Sayfa gonderim odakli.
import { logoRequest } from './client';
import { ensureSession } from './session';
import { ItemWarehouseParam, LogoResult } from '../types';

/** PUT /api/warehouse-params */
export async function saveWarehouseParam(param: ItemWarehouseParam): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/warehouse-params', method: 'PUT', data: param });
}

/** PUT /api/warehouse-params/bulk */
export async function saveWarehouseParamsBulk(params: ItemWarehouseParam[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/warehouse-params/bulk', method: 'PUT', data: params });
}
